{
  "entities": {
    "warehouses": "倉庫 | 倉庫",
    "loadtypes": "貨物類型 | 貨物類型",
    "organizations": "組織 | 組織",
    "orgs": "組織 | 組織"
  }
}
